import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 18 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.43 2.22c0-.529.429-.958.958-.958h10.713c.53 0 .959.429.959.958v3.352c0 .529-.43.958-.959.958H2.388a.96.96 0 0 1-.958-.958zM17.261 14.452a1.526 1.526 0 1 1-3.051 0 1.526 1.526 0 0 1 3.051 0" }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "m6.445 5.861 9.196 8.489M2.387 6.53h10.713c.53 0 .959-.43.959-.958V2.22a.96.96 0 0 0-.959-.958H2.388c-.53 0-.958.429-.958.958v3.352c0 .529.429.958.958.958Zm14.873 7.922a1.526 1.526 0 1 1-3.051 0 1.526 1.526 0 0 1 3.051 0Z"
    }, null, -1)
  ])))
}
export default { render: render }